import React, { useEffect, useState, useMemo } from "react";
import { Form, Button, Col } from "react-bootstrap";
import Fields, {
  marketPlaceFields,
  ConsignmentBloomingdales,
} from "./MerchantApprovalFields";
import * as Constants from "../../../../constants/Constants";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import { ToolTip } from "../../../Common/Tooltip/ToolTip";
import "../../../Common/Tooltip/ToolTip.css";
import "../../../../assets/css/Common.css";
import * as ValidationConstants from "../../../../utils/validations/validator";
import * as regxValidations from "../../../../utils/validations/validations";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import Cookie from "js-cookie";
import CurrencyInput from "react-currency-input-field";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import {
  modifyVDFValues,
  checkMandatoryDocStatus,
  checkOnBoardingStatus,
  checkUserRoles,
} from "../../../../utils/utils";
import OnSubmitErrorMessage from "../../../Common/Errors/OnSubmitErrorMessage";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import MerchantContactsModal from "./MerchantContactsModal/MerchantContactsModal";
import MerchantDbmApprovalModal from "./MerchantContactsModal/MerchantDbmApprovalModal";
import { updateCommonInfo } from "../../../../redux/commonSlice";
import {
  updateServiceData,
  updateVendorProfileDetails,
} from "../../../../redux/serviceSlice";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DVNSetup from "../DVNSetup/DVNSetup";
import {
  httpPostMerchantApprovalApprove,
  httpPostMerchantApprovalReject,
  httpGetVendorStatusDetails,
  httpGetMandatoryDocumentStatus,
  httpPostSubmitToDbmOrMerchOps,
  httpPostMerchantApprovalViewModify,
  httpPostSaveVendorStatusByProfileId,
  httpPostAgreementContractCreate,
  httpGetMerchantStoreLocations,
  httpPostRequestGmmChiefmerchApproval,
  httpGetConsignmentContractStatusById,
} from "../../../../service/httpClient";
import { extractVendorStatus } from "../../OnboardingContainer";
import ConfirmationModal from "../../../Common/ConfirmationModal";
import axios from "../../../../service/axios";
import DynamicOptions from "../Company/DynamicOptions";
import {
  isBloomingdalesMerchantEmail,
  getMultiSelectOptions,
  getMultiSelectValue,
  isValidateDateField,
} from "../../OnboardingHelper";

const getVendorStatusDetails = (profileId) => {
  return httpGetVendorStatusDetails(profileId).then((res) => {
    const vendorStatus = res.data;
    return vendorStatus;
  });
};

const DropDown = (props) => {
  return (
    <Select
      id={props.id}
      className={props.className}
      placeholder={Constants.SELECT_ALL_APPLY}
      options={props.options}
      isMulti={props.multi}
      value={props.value ? props.value : null}
      onChange={props.handleChange}
      isSearchable
      isClearable
    />
  );
};

const MerchantApproval = (props) => {
  const dispatch = useDispatch();

  const store = useSelector(
    ({ service, common }) => ({
      vendorProfile: service.vendorProfile,
      profileId: common.profileId,
      vendorStatus: common.boardingStatuses || {},
      userEmail: common.userEmail,
      duns: common.duns,
      vendorConnectionPlatform: common.vendorConnectionPlatform,
      vendorCorpName: common.vendorCorpName,
      merchantContact: service.merchantContact,
      multipleMerchantContactList: service.multipleMerchantContactList,
      merchandiseType:
        service.vendorProfile?.vendorDetail?.merchandiseType || "",
      needDVN: service.vendorProfile?.vendorDetail?.needDVN,
      mandatoryDocStatusRes: common.mandatoryDocStatusRes,
      vendorProfileStatus: service?.vendorStatus,
      documentList: common?.documentList,
      configValues: common?.configValues,
    }),
    shallowEqual
  );
  const [
    showApproveGmmChiefMerchantModel,
    setShowApproveGmmChiefMerchantModel,
  ] = useState(false);
  const [dbmModalOpen, setDbmModalOpen] = useState(false);
  const [merchantApprovalState, setMerchantApprovalState] = useState({
    merchantDetails: {
      vendorConnectionPlatform: "",
      status: "",
      salesProjections: "",
      productType: "",
      programTypes: [],
      frieghtType: "",
      vendorProfileId: store.profileId,
      id: store.profileId,
      hierarchy: [],
      isDunsPresent: false,
      duns: "",
      dunsExists: false,
      isDunsValidated: true,
      isViewModify: false,
      // Bloomingdale's Consignment Fields
      firstReceiptDate: null,
      endOfProgramDate: null,
      anticipatedAverageStock: null,
      storeLocationsInvolved: null,
    },
    hierarchyDuplicate: false,
    updateStatus: false,
    errorStatus: false,
    errorMsg: "",
    successMsg: "",
    response: [],
    editPermission: false,
    rolePermissionStatus: "",
    showNotes: false,
    moreDetails: false,
    disabledVendor: false,
    disableBtn: true,
    disableOnSubmit: false,
    valuesChanged: false,
    openMerchantModalFlag: false,
    comments: "",
    isEmailSent: false,
    emailErrorMsg: "",
    errors: {},
    merchantApproveErrFlag: false,
    merchantApproveErrMgs: "",
    valuesChangedForSubmitDBMMerchOpsBtn: false,
    storeLocationsList: [],
    availableStoreLocationOptions: [],
    selectedStoreLocation: [],
  });

  const [
    eligibleForSubmitToMerchOps,
    setEligibleForSubmitToMerchOps,
  ] = useState(false);
  const [showSubmitToMerchOps, setShowSubmitToMerchOps] = useState(false);
  const [submitToMerchOpsError, setSubmitToMerchOpsError] = useState("");
  const [hasBrandMapping, setHasBrandMapping] = useState(false);
  const [isShowFrieghtType, setIsShowFrieghtType] = useState(false);
  const [
    isConsignmentContractModified,
    setIsConsignmentContractModified,
  ] = useState(false);

  const [
    submitToMerchOpsActionInProgress,
    setSubmitToMerchOpsActionInProgress,
  ] = useState(false);
  const pageAccessBasedOnRole =
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
      RolePermissionConstants.VMP_PAGEACCESS
    ) === RolePermissionConstants.VIEW;
  const selectAllLocations = { label: "All Locations", value: "all" };
  const todaysDate =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    new Date()
      .getDate()
      .toString()
      .padStart(2, "0");
  const [
    selectedFirstReceiptAndEndDate,
    setSelectedReceiptFirstAndEndDate,
  ] = useState({
    firstReceiptDate: todaysDate,
    endOfProgramDate: todaysDate,
  });
  const handleDbmBtnHandler = () => {
    setDbmModalOpen(true);
  };
  const handleDbmBtnCloseHandler = () => {
    setDbmModalOpen(false);
  };

  const initAdobeSignProc = () => {
    const profileId = store.profileId;
    const {
      vendorDetail: vendorDetail = {},
      primaryContact: primaryContact = {},
      mailAddress: mailAddress = {},
    } = store.vendorProfile;
    const {
      vendorCorpName,
      brandName,
      merchandiseType,
      duns,
      hierarchyDetails,
    } = vendorDetail || {};
    const { firstName, lastName, role } = primaryContact || {};
    const { streetAddress, city, state, zipCode, email } = mailAddress || {};
    const { operatingDivision, dept, vendorNumber } =
      hierarchyDetails?.length > 0 ? hierarchyDetails[0] : {};
    const payloadObj = {
      vendorProfileId: profileId || null,
      vendorCorpName: vendorCorpName || null,
      brandName: brandName || null,
      merchandiseType: merchandiseType || null,
      vendorPrimaryContactName: firstName + " " + lastName || null,
      vendorPrimaryRole: role || null,
      mailingStreetAddress: streetAddress || null,
      city: city || null,
      state: state || null,
      zipCode: zipCode || null,
      vendorContractEmail: email || null,
      division: operatingDivision || null,
      dept: dept || null,
      vendorNbr: vendorNumber || null,
      duns: duns || null,
      apVpEmail: "",
      contractType: Constants.CONSIGNMENT_TYPE,
      vendorSignOrder: 2,
      vpSignOrder: 1,
      merchantContractEmail: Constants.TEST_CONSIGNMENT_APVP_EMAIL,
    };

    return httpPostAgreementContractCreate(payloadObj)
      .then((res) => {
        if (res?.status === 200) {
          setMerchantApprovalState((merchantApprovalState) => ({
            ...merchantApprovalState,
            errorMsg: "",
            errorStatus: false,
          }));
          return res;
        } else {
          setMerchantApprovalState((merchantApprovalState) => ({
            ...merchantApprovalState,
            errorMsg: Constants.API_INIT_ADOBE_SIGN_ERROR_MSG,
            errorStatus: true,
          }));
          return false;
        }
      })
      .catch((error) => {
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          errorMsg: Constants.API_INIT_ADOBE_SIGN_ERROR_MSG,
          errorStatus: true,
        }));
        return false;
      });
  };

  const handleSubmitToAPVPHandler = () => {
    initAdobeSignProc()
      .then((res) => {
        if (res) {
          let { contractModified = false } = res?.data;
          setIsConsignmentContractModified(contractModified);

          let vendorAccountsPayableVPReview =
            store?.vendorProfileStatus.length > 0
              ? store?.vendorProfileStatus.find(
                  (item) =>
                    item.statusName === Constants.ACCOUNT_PAYABLE_VP_REVIEW &&
                    item.vendorStatus?.statusId === 34
                )
              : {};
          const userEmail = Cookie.get("email")
            ? Cookie.get("email").toLowerCase()
            : "";
          const updatedByFullName = Cookie.get("userName")
            ? Cookie.get("userName")
            : "";
          const payLoad = {
            ...vendorAccountsPayableVPReview,
            vendorStatus: {
              ...vendorAccountsPayableVPReview.vendorStatus,
              lastStatusUpdatedValue: Constants.APPROVED,
              lastStatusUpdatedBy: userEmail,
            },
            userEmail,
            updatedByFullName,
          };

          httpPostSaveVendorStatusByProfileId(payLoad)
            .then((res) => {
              if (res?.status === 200) {
                props.refreshDataAfterActionSuccessful(res?.data);
              } else {
                setMerchantApprovalState((merchantApprovalState) => ({
                  ...merchantApprovalState,
                  errorMsg: Constants.API_ERROR_MSG,
                  errorStatus: true,
                }));
              }
            })
            .catch((err) => {
              setMerchantApprovalState((merchantApprovalState) => ({
                ...merchantApprovalState,
                errorMsg: Constants.API_ERROR_MSG,
                errorStatus: true,
              }));
            });
        }
      })
      .catch((error) => {
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          errorMsg: Constants.API_INIT_ADOBE_SIGN_ERROR_MSG,
          errorStatus: true,
        }));
      });
  };

  const getVendorConnectionPlatform = () =>
    store.vendorStatus[Constants.LIVE_ID] === Constants.APPROVED
      ? store.vendorConnectionPlatform
      : "";

  const validator = useMemo(
    () =>
      new SimpleReactValidator({
        validators: {
          productType: {
            message: "Length of product type should be less than 30.",
            rule: (val, params, validator) => {
              if (val) {
                return val.length < 30;
              }
              return true;
            },
            required: false,
          },

          salesProjections: {
            message: "The annual sales volume field is required.",
            rule: (val, params, validator) => !!val,
            required: false,
          },
          anticipatedAverageStock: {
            message: "The anticipated average stock is required.",
            rule: (val, params, validator) => !!val,
            required: false,
          },
          storeLocationsInvolved: {
            message: "The store locations involved is required.",
            rule: (val, params, validator) => !!val,
            required: false,
          },
          vendorConnectionPlatform: {
            message: Constants.MA_CHANGE_VDF_ERR_MSG,
            rule: (val, params, validator) => {
              const vConnPlt = getVendorConnectionPlatform();
              if (modifyVDFValues(vConnPlt)) {
                validator.showMessageFor("vendorConnectionPlatform");
                return val === modifyVDFValues(vConnPlt);
              }
            },
            required: false,
          },
        },
      }),
    [store.vendorStatus]
  );

  useEffect(() => {
    if (store?.documentList?.length === 0)
      props.getDocumentList(store?.profileId);
  }, [store?.profileId]);

  useEffect(() => {
    setUserPermission();
    validateMerchantData();
    getUserRolePermission(
      RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
      RolePermissionConstants.VMP_SUBMIT_TO_ACCOUNT_PAYABLE_VP
    ) === RolePermissionConstants.EDIT &&
      store?.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT &&
      !isConsignmentContractModified &&
      getConsignmentAgreementDetails();
  }, []);

  const [
    disableSubmitDBMForMbeWbeVendorSign,
    setDisableSubmitDBMForMbeWbeVendorSign,
  ] = useState(false);
  useEffect(() => {
    store?.vendorProfile?.vendorDetail?.certifiedAsMinority &&
      store.vendorProfile?.vendorDetail?.isAffidavit &&
      store.vendorStatus.onboardingStatus &&
      store.vendorStatus.onboardingStatus === Constants.MERCHANT_APPROVED &&
      store?.vendorProfile?.vendorDetail?.isPrimaryVendor &&
      getMbeWbeAgreementDetails();
  }, [store.vendorStatus.onboardingStatus]);

  useEffect(() => {
    setEligibleForSubmitToMerchOps(store.mandatoryDocStatusRes);
  }, [store.mandatoryDocStatusRes]);

  useEffect(() => {
    setMerchantData();
  }, [store.vendorProfile]);

  useEffect(() => {
    validateMerchantData();
  }, [merchantApprovalState.merchantDetails]);

  useEffect(() => {
    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      merchantDetails: {
        ...merchantApprovalState.merchantDetails,
        isViewModify: hasBrandMapping,
      },
    }));
  }, [hasBrandMapping]);

  useEffect(() => {
    isBloomingdalesMerchantEmail(
      store?.merchantContact?.email,
      store?.merchandiseType
    ) &&
      merchantApprovalState?.storeLocationsList?.length === 0 &&
      getStoreLocationList();
  }, []);

  const getStoreLocationList = () => {
    httpGetMerchantStoreLocations(Constants.BLOOMINGDALES_DIVISION_NUMBER)
      .then((res) => {
        if (res?.status === 200 && res?.data?.length > 0) {
          let storeLocationArr = [];
          res.data.map((storeLoc) => {
            let storeLocationObj = {
              label: storeLoc.storeLocId + " - " + storeLoc.storeLocationAbbr,
              value: storeLoc.storeLocationAbbr,
            };

            return storeLocationArr.push(storeLocationObj);
          });

          const { vendorProfile = {} } = store;
          const { vendorDetail = {} } = vendorProfile;
          const { storeLocationsInvolved = null } = vendorDetail;
          const updateStoreLocations =
            storeLocationsInvolved !== null &&
            storeLocationsInvolved?.length > 0
              ? storeLocationsInvolved?.length === storeLocationArr?.length
                ? [selectAllLocations]
                : storeLocationsInvolved.map((storeLoc) => {
                    let storeLocObj = {
                      label: storeLoc,
                      value: storeLoc,
                    };

                    return storeLocObj;
                  })
              : [];
          const updateAvailableStoreLocationOptions =
            storeLocationsInvolved?.length > 0 &&
            storeLocationsInvolved?.length === storeLocationArr?.length
              ? []
              : [selectAllLocations, ...storeLocationArr];

          setMerchantApprovalState((merchantApprovalState) => ({
            ...merchantApprovalState,
            storeLocationsList: [selectAllLocations, ...storeLocationArr],
            selectedStoreLocation: updateStoreLocations,
            availableStoreLocationOptions: updateAvailableStoreLocationOptions,
          }));
        } else {
          setMerchantApprovalState((merchantApprovalState) => ({
            ...merchantApprovalState,
            errorMsg: Constants.API_ERROR_MSG,
            errorStatus: true,
          }));
        }
      })
      .catch((err) => {
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          errorMsg: Constants.API_ERROR_MSG,
          errorStatus: true,
        }));
      });
  };

  const {
    history: {
      location: { state: { mandatoryDocsUploaded = null } = {} } = {},
    } = {},
  } = props;

  useEffect(() => {
    if (mandatoryDocsUploaded !== null) {
      setEligibleForSubmitToMerchOps(mandatoryDocsUploaded);
    }
  }, [mandatoryDocsUploaded]);

  const setUserPermission = () => {
    let editPermissionFlag;
    let rolePermissionFlag;

    if (
      RolePermissionConstants.EDIT ===
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
        RolePermissionConstants.ALL
      )
    ) {
      editPermissionFlag = true;
      rolePermissionFlag = RolePermissionConstants.EDIT;
    } else if (
      RolePermissionConstants.VIEW ===
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
        RolePermissionConstants.ALL
      )
    ) {
      editPermissionFlag = false;
      rolePermissionFlag = RolePermissionConstants.VIEW;
      let formElements = document?.forms?.merchantForm?.elements;
      if (formElements && formElements.length > 0) {
        for (let i = 0; i < formElements.length; i++) {
          formElements[i].disabled = true;
        }
      }
    } else {
      editPermissionFlag = false;
      rolePermissionFlag = RolePermissionConstants.NONE;
    }
    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      editPermission: editPermissionFlag,
      rolePermissionStatus: rolePermissionFlag,
    }));
  };

  const validateMerchantData = () => {
    let disableBtn = false;
    let disableBtnForInvalidField = false;
    let disableBtnForInvalidHierarchy = false;
    let disableBtnForInvalidDuns = false;

    let updatedMerchantDetails = { ...merchantApprovalState.merchantDetails };
    const {
      hierarchy,
      duns,
      isDunsPresent,
      isDunsValidated,
    } = updatedMerchantDetails;

    Fields.forEach(({ fieldId }) => {
      if (!disableBtn && updatedMerchantDetails[fieldId] === "1.0 Vendor") {
        disableBtnForInvalidField = true;
      }
    });

    // Below code is to introduce form validation against Hierarchy values

    if (hierarchy?.length > 0) {
      hierarchy.forEach((hier) => {
        const { dept, operatingDivision, vendorNumber } = hier;

        if (!dept || !operatingDivision || vendorNumber === "") {
          disableBtnForInvalidHierarchy = true;
        }
      });
    } else {
      disableBtnForInvalidHierarchy = false;
    }

    if ((duns && !regxValidations.isValidDuns(duns)) || !isDunsValidated) {
      disableBtnForInvalidDuns = true;
    }

    if (
      disableBtnForInvalidField ||
      disableBtnForInvalidHierarchy ||
      isDunsPresent ||
      disableBtnForInvalidDuns
    ) {
      disableBtn = true;
    }
    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      disableBtn,
    }));
  };

  const setMerchantData = () => {
    const { vendorDetail } = store.vendorProfile;

    let updateMerchantDetails = { ...merchantApprovalState.merchantDetails };

    updateMerchantDetails["vendorConnectionPlatform"] =
      store.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT
        ? Constants.STATUS_PLATFORMTYPE_DIRECTEDI
        : modifyVDFValues(vendorDetail["vendorConnectionPlatform"]);
    updateMerchantDetails["salesProjections"] =
      vendorDetail["salesProjections"];
    updateMerchantDetails["productType"] = vendorDetail["productGrp"];
    updateMerchantDetails["frieghtType"] = vendorDetail["frieghtType"] || "";
    updateMerchantDetails["status"] =
      vendorDetail["status"] === Constants.APPROVED
        ? Constants.APPROVED
        : Constants.REJECTED;

    const hierarchyDetails = vendorDetail["hierarchyDetails"] || [];
    updateMerchantDetails["hierarchy"] = [...hierarchyDetails];

    updateMerchantDetails["duns"] = vendorDetail.duns || "";

    if (hierarchyDetails && hierarchyDetails.length > 0) {
      const programTypeArr = hierarchyDetails[0]?.programTypes;
      let progTypeArr = [];

      if (programTypeArr && programTypeArr.length > 0) {
        programTypeArr.map((progType) => {
          let programTypeObj = {
            label: progType,
            value: progType,
          };

          progTypeArr.push(programTypeObj);
        });
      }
      updateMerchantDetails["programTypes"] = progTypeArr;
    }

    //Set the primary dvn flag
    updateMerchantDetails["needDVN"] =
      vendorDetail["needDVN"] === "true" ? true : false;

    if (store?.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE) {
      updateMerchantDetails["merchantCategoryCode"] =
        vendorDetail?.merchantCategoryCode || "";
      updateMerchantDetails["returnLessRefundOptIn"] =
        vendorDetail?.returnLessRefundOptIn === true
          ? "Yes"
          : vendorDetail?.returnLessRefundOptIn === false
          ? "No"
          : "";
      updateMerchantDetails["dRaasSignatureRequiredForReturns"] =
        vendorDetail?.dRaasSignatureRequiredForReturns === true
          ? "Yes"
          : vendorDetail?.dRaasSignatureRequiredForReturns === false
          ? "No"
          : "";
      updateMerchantDetails["isInternationalSeller"] =
        vendorDetail?.isInternationalSeller === true
          ? "Yes"
          : vendorDetail?.isInternationalSeller === false
          ? "No"
          : "";
      updateMerchantDetails["deliveryRaasOptIn"] =
        vendorDetail?.deliveryRaasOptIn === true
          ? "Yes"
          : vendorDetail?.deliveryRaasOptIn === false
          ? "No"
          : "";
    }
    updateMerchantDetails["firstReceiptDate"] =
      vendorDetail?.firstReceiptDate || null;
    updateMerchantDetails["endOfProgramDate"] =
      vendorDetail?.endOfProgramDate || null;
    updateMerchantDetails["anticipatedAverageStock"] =
      vendorDetail?.anticipatedAverageStock || null;
    updateMerchantDetails["storeLocationsInvolved"] =
      vendorDetail?.storeLocationsInvolved || null;

    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      merchantDetails: { ...updateMerchantDetails },
    }));
    setSelectedReceiptFirstAndEndDate({
      firstReceiptDate: updateMerchantDetails["firstReceiptDate"]
        ? updateMerchantDetails["firstReceiptDate"]
        : todaysDate,
      endOfProgramDate: updateMerchantDetails["endOfProgramDate"],
    });
    if (
      vendorDetail["vendorConnectionPlatform"] ===
      Constants.STATUS_PLATFORMTYPE_DIRECTEDIRDS
    ) {
      setIsShowFrieghtType(true);
    } else {
      setIsShowFrieghtType(false);
    }
  };

  const transformValue = (e) => {
    return e === "$" ? "000" : e;
  };

  const onChange = (key, e) => {
    let valueChanged = false;
    const { updateStatus, errorStatus } = merchantApprovalState || {};

    if (updateStatus || errorStatus) {
      resetMessage();
    }

    let updatedMerchantDetails = { ...merchantApprovalState.merchantDetails };
    let errorObj = { ...merchantApprovalState.errors };

    if (key === "salesProjections" || key === "anticipatedAverageStock") {
      if (e) {
        valueChanged = true;
        updatedMerchantDetails[key] = e === "000" ? null : e;
      }
    } else if (key === "vendorConnectionPlatform") {
      updatedMerchantDetails[key] = e.target?.value || "";
      updatedMerchantDetails["programTypes"] = [];
      updatedMerchantDetails["frieghtType"] = "";
      errorObj = {};
      valueChanged = true;
      if (e.target.value === Constants.STATUS_PLATFORMTYPE_DIRECTEDIRDS) {
        setIsShowFrieghtType(true);
      } else {
        setIsShowFrieghtType(false);
      }
    } else if (key === "firstReceiptDate") {
      const diffTime =
        new Date(selectedFirstReceiptAndEndDate?.endOfProgramDate) -
        new Date(e.target?.value);
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      setSelectedReceiptFirstAndEndDate({
        ...selectedFirstReceiptAndEndDate,
        firstReceiptDate: e.target?.value,
      });
      updatedMerchantDetails[key] = e.target?.value || null;
      if (!isValidateDateField(e.target?.value)) {
        valueChanged = false;
        errorObj[key] = Constants.DATE_FIELD_ERROR_MESSAGE;
      } else {
        valueChanged = true;
        delete errorObj[key];
      }
      if (diffDays < 0) {
        updatedMerchantDetails["endOfProgramDate"] = null;
      }
    } else if (key === "endOfProgramDate") {
      const diffTime =
        new Date(e.target?.value) -
        new Date(selectedFirstReceiptAndEndDate?.firstReceiptDate);
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      setSelectedReceiptFirstAndEndDate({
        ...selectedFirstReceiptAndEndDate,
        endOfProgramDate: e.target?.value,
      });
      updatedMerchantDetails[key] = e.target?.value || null;
      if (!isValidateDateField(e.target?.value)) {
        valueChanged = false;
        errorObj[key] = Constants.DATE_FIELD_ERROR_MESSAGE;
      } else if (diffDays < 0) {
        valueChanged = false;
        errorObj[key] = Constants.END_PROGRAM_DATE_FIELD_ERROR_MESSAGE;
      } else {
        valueChanged = true;
        delete errorObj[key];
      }
    } else {
      updatedMerchantDetails[key] = e.target?.value || "";
      valueChanged = true;
    }

    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      merchantDetails: updatedMerchantDetails,
      valuesChanged: valueChanged,
      errors: errorObj,
      valuesChangedForSubmitDBMMerchOpsBtn: true,
    }));
    validateMerchantData();
  };

  const validFormFields = () => {
    return Object.keys(merchantApprovalState.errors).length === 0 &&
      merchantApprovalState.errors.constructor === Object
      ? true
      : false;
  };

  const showError = (type, field, value) => {
    switch (type) {
      case "custom":
        return validator.message(field, value, field);
      case "number":
        return validator.message(field, value, ValidationConstants.ONLY_DIGITS);
      case "req":
        if (field === "productType") {
          return validator.message(
            field,
            value,
            ValidationConstants.MA_PRODUCT_TYPE_VALIDATION
          );
        }
        if (field === "vendorConnectionPlatform") {
          return validator.message(field, value, ValidationConstants.VDF);
        } else {
          return validator.message(field, value, ValidationConstants.REQUIRED);
        }

      default:
        break;
    }
  };
  const setDamageAllowanceAllowedDigits = (field, value) => {
    if (value) {
      let damageAllDigits = value.split(".");
      if (damageAllDigits[1] && damageAllDigits[1].length > 1) {
        let updatedMerchantDetails = {
          ...merchantApprovalState.merchantDetails,
        };
        updatedMerchantDetails[field] = damageAllDigits[0]
          .concat(".")
          .concat(damageAllDigits[1].charAt(0));
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          merchantDetails: updatedMerchantDetails,
        }));
      }
    }
  };

  const showErrorMsg = (field, index, e) => {
    if (!validator.fieldValid(field)) {
      validator.showMessageFor(field);
      setMerchantApprovalState((merchantApprovalState) => ({
        ...merchantApprovalState,
        hasErrorIndex: index,
      }));
    } else {
      setMerchantApprovalState((merchantApprovalState) => ({
        ...merchantApprovalState,
        hasErrorIndex: -1,
      }));
      validator.hideMessageFor(field);
    }

    validateMerchantData();
  };

  const onUpdateMerchantSection = (data, flag = false, dvnData = {}) => {
    let approveOrReject;
    if (data.hierarchy && data.hierarchy.length > 0) {
      // Add the same duns for each hierarchy
      data = {
        ...data,
        hierarchy: data.hierarchy.map((item) => {
          let updtHier = item;
          updtHier.returnDisposition =
            item?.returnDisposition !== null ? item.returnDisposition : "";
          if (
            store.merchandiseType === Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
          ) {
            updtHier.receiptAllowance = null;
            updtHier.salvageAllowance = null;
          } else {
            updtHier.salvageAllowance =
              item?.salvageAllowance !== null ? item.salvageAllowance : 0;
            updtHier.receiptAllowance =
              item?.receiptAllowance !== null ? item.receiptAllowance : 0;
          }
          return {
            ...updtHier,
            duns: data.duns,
          };
        }),
      };
    }

    if (flag) {
      httpPostMerchantApprovalViewModify(data)
        .then((res) => {
          // update vendorProfile in store from merchantDetails if required
          dispatch(
            updateVendorProfileDetails({
              hierarchyDetails: res.data.hierarchy,
              duns: res.data.duns,
              frieghtType: data.frieghtType,
              needDVN: res.data.needDVN,
              productGrp: data.productType,
              salesProjections: data.salesProjections,
              vendorConnectionPlatform: data.vendorConnectionPlatform,
              lastUpdatedBy: data.userEmail,
              firstReceiptDate: data.firstReceiptDate,
              endOfProgramDate: data.endOfProgramDate,
              anticipatedAverageStock: data.anticipatedAverageStock,
              storeLocationsInvolved: data.storeLocationsInvolved,
            })
          );
          dispatch(
            updateCommonInfo({
              duns: res.data.duns,
              vendorConnectionPlatform: data.vendorConnectionPlatform,
            })
          );

          if (flag) {
            navigateBrand(dvnData);
          }
        })
        .catch((err) => console.log("failing service for view/modify", err));
    } else {
      if (data && data.status && data.status === Constants.APPROVED) {
        approveOrReject = httpPostMerchantApprovalApprove;
      } else {
        approveOrReject = httpPostMerchantApprovalReject;
      }
      if (approveOrReject) {
        approveOrReject(data)
          .then((res) => {
            const responseStatus = res.data && res.data.status;

            if (responseStatus) {
              // update vendorProfile in store from merchantDetails if required
              dispatch(
                updateVendorProfileDetails({
                  hierarchyDetails: res.data.hierarchy,
                  duns: res.data.duns,
                  frieghtType: data.frieghtType,
                  needDVN: res.data.needDVN,
                  productGrp: data.productType,
                  salesProjections: data.salesProjections,
                  status: responseStatus,
                  vendorConnectionPlatform: data.vendorConnectionPlatform,
                  lastUpdatedBy: data.userEmail,
                  firstReceiptDate: data.firstReceiptDate,
                  endOfProgramDate: data.endOfProgramDate,
                  anticipatedAverageStock: data.anticipatedAverageStock,
                  storeLocationsInvolved: data.storeLocationsInvolved,
                })
              );
              dispatch(
                updateCommonInfo({
                  duns: res.data.duns,
                  vendorConnectionPlatform: data.vendorConnectionPlatform,
                })
              );
              //Update vendor status in store
              Promise.allSettled([
                getVendorStatusDetails(store.profileId),
                checkIfEligibleForSubmitToMerchOps(),
              ])
                .then(([statusRes, docStatusRes]) => {
                  let vendorStatus = statusRes?.value || [];
                  const { mutatedVendorStatus } = extractVendorStatus(
                    responseStatus,
                    vendorStatus
                  );
                  setMerchantApprovalState((merchantApprovalState) => ({
                    ...merchantApprovalState,
                    disableOnSubmit: false,
                    updateStatus: true,
                    errorStatus: false,
                    merchantApproveErrMgs: "",
                    successMsg:
                      responseStatus === Constants.APPROVED
                        ? Constants.MERCHANT_APPROVED_MSG
                        : responseStatus === Constants.PENDING
                        ? Constants.MERCHANT_APPROVED_SAVE_MSG
                        : Constants.MERCHANT_REJECTED_MSG,
                    merchantDetails: {
                      ...merchantApprovalState.merchantDetails,
                      vendorConnectionPlatform: data.vendorConnectionPlatform,
                    },
                    merchantApproveErrFlag: false,
                    valuesChangedForSubmitDBMMerchOpsBtn: false,
                  }));
                  dispatch(updateServiceData({ vendorStatus }));
                  dispatch(
                    updateCommonInfo({
                      boardingStatuses: mutatedVendorStatus,
                      duns: data.duns,
                      vendorConnectionPlatform: data.vendorConnectionPlatform,
                      mandatoryDocStatusRes: docStatusRes?.value || false,
                    })
                  );
                })
                .catch((error) => {
                  console.log("Error during vendor status reload: ", error);
                });
            } else {
              setMerchantApprovalState((merchantApprovalState) => ({
                ...merchantApprovalState,
                errorMsg:
                  Constants.MERCHANT_APPROVAL_MSG.MERCHANT_APPROVAL_ERROR_MSG,
                disableOnSubmit: false,
                errorStatus: true,
                updateStatus: false,
                merchantDetails: {
                  ...merchantApprovalState.merchantDetails,
                  vendorConnectionPlatform: data.vendorConnectionPlatform,
                },
                merchantApproveErrFlag: false,
                merchantApproveErrMgs: "",
              }));
            }
          })
          .catch((err) => {
            console.log("Error in Merchant approve:", err);
            const { messageId, message = "" } = err?.response?.data || {};
            if (messageId === 802) {
              setMerchantApprovalState((merchantApprovalState) => ({
                ...merchantApprovalState,
                disableOnSubmit: false,
                valuesChanged: true,
                merchantApproveErrFlag: true,
                merchantApproveErrMgs: message,
              }));
            } else {
              const errorMessage =
                message !== ""
                  ? message
                  : Constants.MERCHANT_APPROVAL_MSG.MERCHANT_APPROVAL_ERROR_MSG;
              setMerchantApprovalState((merchantApprovalState) => ({
                ...merchantApprovalState,
                disableOnSubmit: false,
                valuesChanged: true,
                errorMsg: errorMessage,
                errorStatus: true,
                updateStatus: false,
                merchantApproveErrFlag: false,
                merchantApproveErrMgs: "",
              }));
            }
          });
      }
    }
  };

  const resetMessage = () => {
    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      updateStatus: false,
      errorStatus: false,
      successMsg: "",
      errorMsg: "",
    }));
  };

  const navigateBrand = (dvnData) => {
    props.history.push({
      pathname: `/boarding/merchant/merchantbrand/${store.profileId}`,
      param: "merchantbrand",
      state: dvnData,
    });
  };

  const checkIfWeCanUpdateData = () => {
    // This function will return true or false
    // If duns is not given it will return true
    // If duns is given it will first check if that is already exist with other vendor or not
    // If exist will return false
    // If not exist will return true and that means its a new duns and can be assigned to this vendor

    return new Promise((resolve, reject) => {
      const { vendorDetail } = store.vendorProfile;

      //When duns is not given
      if (
        merchantApprovalState.merchantDetails.duns === "" ||
        merchantApprovalState.merchantDetails.duns === null ||
        !vendorDetail.isPrimaryVendor
      ) {
        //Duns is not provided hence return true
        resolve(true);
        return;
      }

      //When duns is given
      if (
        regxValidations.isValidDuns(
          merchantApprovalState.merchantDetails.duns
        ) &&
        store.userEmail
      ) {
        //Given duns is in proper format hence prepare to call the api
        const vendorDetail = store.vendorDetails;
        var encodeUserEmail = encodeURIComponent(store.userEmail);

        //CorpName will be "MERCH" as it is being called from Merchant Approval page
        var encodeCorpNm = Constants.MERCH;

        var isPrimaryVendor =
          vendorDetail?.isPrimaryVendor === undefined ||
          vendorDetail?.isPrimaryVendor
            ? true
            : false;

        //Call the to check if duns already present in other vendor record
        axios()
          .get(
            `/vendorProfile/validateDunsAndCorpName?duns=${merchantApprovalState.merchantDetails.duns}&corpName=${encodeCorpNm}&email=${encodeUserEmail}&isPrimaryVendor=${isPrimaryVendor}`
          )
          .then((res) => {
            if (res && res.data) {
              const ifOwnVendorProfile = res.data.ownVendorProfile;
              const ifVendorPresent = res.data.vendorPresent;

              //if ifOwnVendorProfile=false and ifVendorPresent=true that means the provided duns is already present in other vendor profile

              if (
                (ifOwnVendorProfile === false && ifVendorPresent === false) ||
                ifOwnVendorProfile === true ||
                ifVendorPresent === false
              ) {
                dunsValidatorHandler({
                  isDunsPresent: false,
                  dunsExists: false,
                });
                resolve(true);
              } else {
                dunsValidatorHandler({
                  isDunsPresent: true,
                  dunsExists: true,
                });
                resolve(false);
              }
            } else {
              resolve(false);
            }
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      }
    });
  };

  const submitMerchantContactApproval = (event, flag = false, dvnData = {}) => {
    event.preventDefault();
    event.persist();

    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      valuesChanged: false,
      disableOnSubmit: true,
    }));

    checkIfWeCanUpdateData()
      .then((status) => {
        if (status) {
          let updatedMerchantDetails = {
            ...merchantApprovalState.merchantDetails,
          };
          const { hierarchy, duns } = updatedMerchantDetails || {};
          // let programTypesArr = [];
          let hierarchyArr = [];

          // if (programTypes && programTypes.length > 0) {
          //   programTypesArr = [...programTypes].map((item) => item.value);
          // }

          if (hierarchy && hierarchy.length > 0) {
            hierarchyArr = [...hierarchy].map((item) => ({
              ...item,
              programTypes: item.programTypes,
              dvnRequestedBy: item.dvnRequestedBy
                ? item.dvnRequestedBy
                : Cookie.get("email"),
            }));
          }

          if (event.target.id === "merApproveBtn" || flag) {
            updatedMerchantDetails["status"] = "Approved";
            setMerchantApprovalState((merchantApprovalState) => ({
              ...merchantApprovalState,
              status: "Approved",
            }));
          } else if (event.target.id === "rejectBtn") {
            updatedMerchantDetails["status"] = "Rejected";
            setMerchantApprovalState((merchantApprovalState) => ({
              ...merchantApprovalState,
              status: "Rejected",
            }));
          }

          if (
            merchantApprovalState.valuesChanged ||
            [
              Constants.APPROVED,
              Constants.REJECTED,
              Constants.PENDING,
            ].includes(store?.vendorStatus?.merchantApproval)
          ) {
            onUpdateMerchantSection(
              {
                ...{
                  ...updatedMerchantDetails,
                  hierarchy: hierarchyArr,
                  merchantEmail: store.merchantContact?.email,
                  merchandiseType: store.merchandiseType,
                },
                userEmail: Cookie.get("email"),
                duns,
              },
              flag,
              dvnData
            );
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          valuesChanged: true,
          disableOnSubmit: false,
        }));
      });
  };

  const getFields = (fields, index) => {
    let field = {};
    const { setupDvn = "" } = store.vendorStatus || {};
    const disableFields = setupDvn === Constants.APPROVED ? true : false;

    switch (fields.fieldType) {
      case "text":
        let fieldValue =
          merchantApprovalState.merchantDetails[fields.fieldId] || "";

        if (
          store.merchandiseType ===
            Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
          fields.fieldId === "vendorConnectionPlatform"
        ) {
          const selectedOption = fields.option.find(
            (item) => item.optionValue === fieldValue
          );
          if (selectedOption) {
            fieldValue = selectedOption.optionName;
          }
        }

        field = (
          <Form.Group as={Col} md={4} key={index}>
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={fields.fieldId !== "allowanceRate" && Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <Form.Control
              type={fields.fieldType}
              id={fields.fieldId}
              name={fields.fieldId}
              value={fieldValue}
              maxLength={fields.maxLength}
              onBlur={(e) =>
                showErrorMsg(fields.fieldId, fields.fieldId + index, e)
              }
              onChange={(event) => onChange(fields.fieldId, event)}
              className={
                merchantApprovalState.hasErrorIndex === fields.fieldId + index
                  ? "has-error"
                  : ""
              }
              disabled={
                !merchantApprovalState.editPermission ||
                store.merchandiseType ===
                  Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
              }
            />
            {showError(
              fields.validateType,
              fields.fieldId,
              merchantApprovalState.merchantDetails[fields.fieldId]
            )}
          </Form.Group>
        );
        break;
      case "USDNumber":
        field = (
          <Form.Group as={Col} md={4} key={index}>
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <CurrencyInput
              className={`form-control ${
                merchantApprovalState.hasErrorIndex === fields.fieldId + index
                  ? "has-error"
                  : ""
              }`}
              maxLength={fields.maxLength}
              value={
                merchantApprovalState.merchantDetails[fields.fieldId] !== null
                  ? merchantApprovalState.merchantDetails[fields.fieldId]
                  : ""
              }
              transformRawValue={transformValue}
              onValueChange={(e) => onChange(fields.fieldId, e)}
              decimalsLimit={0}
              groupSeparator=","
              prefix="$"
              allowNegativeValue={false}
              onBlur={(e) =>
                showErrorMsg(fields.fieldId, fields.fieldId + index, e)
              }
              disabled={!merchantApprovalState.editPermission}
            />
            {showError(
              fields.validateType,
              fields.fieldId,
              merchantApprovalState.merchantDetails[fields.fieldId]
            )}
          </Form.Group>
        );
        break;
      case "select":
        if (
          store.merchandiseType !==
            Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
          fields.fieldId === "vendorConnectionPlatform"
        ) {
          fields.option = fields.option.filter(
            (item) =>
              !Constants.STATUS_PLATFORMTYPE_MIRAKL.includes(item.optionValue)
          );
        }

        field = (
          <Form.Group
            as={Col}
            className={
              fields.fieldId !== "frieghtType" ||
              (fields.fieldId === "frieghtType" &&
                isShowFrieghtType &&
                merchantApprovalState.merchantDetails[
                  "vendorConnectionPlatform"
                ] === Constants.STATUS_PLATFORMTYPE_DIRECTEDIRDS)
                ? "field_show"
                : "field_hide"
            }
            md={4}
            key={index}
          >
            {fields.fieldId !== "frieghtType" ? (
              <ToolTip
                toolTipId={fields.toolTipId}
                customStyles="compDetailsFormLabel"
                label={fields.fieldLabel}
                mandate={Constants.REQUIRED}
                toolTipText={fields.toolTipText}
              />
            ) : (fields.fieldId === "frieghtType" && isShowFrieghtType) ||
              fields.fieldId !== "frieghtType" ? (
              <Form.Label
                id={fields.fieldId}
                className="compDetailsFormLabel"
                style={{ marginBottom: "0px" }}
              >
                {fields.fieldLabel}
                <span className="required">
                  {fields.fieldId === "frieghtType" &&
                  merchantApprovalState.merchantDetails[
                    "vendorConnectionPlatform"
                  ] === Constants.NEW_BIG_TKT_VENDOR_FLAG
                    ? "*"
                    : ""}
                </span>
              </Form.Label>
            ) : (
              ""
            )}
            {(fields.fieldId === "frieghtType" && isShowFrieghtType) ||
            fields.fieldId !== "frieghtType" ? (
              <Form.Control
                as="select"
                id={fields.fieldId}
                onChange={(e) => onChange(fields.fieldId, e)}
                defaultValue={Constants.SELECT}
                value={merchantApprovalState.merchantDetails[fields.fieldId]}
                className={
                  merchantApprovalState?.errors[fields.fieldId]
                    ? "react-select has-error searchSelect"
                    : "react-select"
                }
                disabled={
                  (fields.fieldId === "frieghtType" &&
                    merchantApprovalState.merchantDetails[
                      "vendorConnectionPlatform"
                    ] !== Constants.NEW_BIG_TKT_VENDOR_FLAG) ||
                  (fields.fieldId === "operatingDivision" && disableFields) ||
                  !merchantApprovalState.editPermission ||
                  (fields.fieldId === "vendorConnectionPlatform" &&
                  store.vendorProfile?.profileTypeDetails?.length > 1
                    ? true
                    : false) ||
                  (fields.fieldId === "vendorConnectionPlatform" &&
                    props.onboardStatusBeyondInprocessStatusFlag) ||
                  (fields.fieldId === "vendorConnectionPlatform" &&
                  store.merchandiseType ===
                    Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT
                    ? true
                    : false)
                }
              >
                {fields.fieldId === "vendorConnectionPlatform" && (
                  <DynamicOptions
                    labelName="vendorConnectionPlatform"
                    responseValue={
                      merchantApprovalState.merchantDetails[fields.fieldId]
                    }
                    configValues={store?.configValues}
                  />
                )}

                {fields.fieldId === "frieghtType" && (
                  <DynamicOptions
                    labelName="frieghtType"
                    responseValue={
                      merchantApprovalState.merchantDetails[fields.fieldId]
                    }
                    configValues={store?.configValues}
                  />
                )}
              </Form.Control>
            ) : (
              ""
            )}
            {showError(
              fields.validateType,
              fields.fieldId,
              merchantApprovalState.merchantDetails[fields.fieldId]
            )}
            {merchantApprovalState.errors &&
              merchantApprovalState.errors[fields.fieldId] && (
                <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                  {merchantApprovalState.errors[fields.fieldId]}
                </div>
              )}
          </Form.Group>
        );
        break;
      case "searchSelect":
        field = (
          <Form.Group
            as={Col}
            md={fields.fieldId === "storeLocationsInvolved" ? 6 : 4}
          >
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              mandate={Constants.REQUIRED}
              toolTipText={fields.toolTipText}
            />
            <DropDown
              id={fields.fieldId}
              options={merchantApprovalState?.availableStoreLocationOptions}
              value={merchantApprovalState?.selectedStoreLocation}
              handleChange={onStoreLocationsChange}
              className={
                merchantApprovalState?.errors[fields.fieldId]
                  ? "react-select has-error searchSelect"
                  : "react-select"
              }
              multi={fields.multiSelect}
            />
            {showError(
              fields.validateType,
              fields.fieldId,
              merchantApprovalState.merchantDetails[fields.fieldId]
            )}
            {merchantApprovalState.errors &&
              merchantApprovalState.errors[fields.fieldId] && (
                <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                  {merchantApprovalState.errors[fields.fieldId]}
                </div>
              )}
          </Form.Group>
        );
        break;
      case "date":
        field = (
          <Form.Group as={Col} md={4} key={index}>
            <ToolTip
              toolTipId={fields.toolTipId}
              customStyles="compDetailsFormLabel"
              label={fields.fieldLabel}
              toolTipText={fields.toolTipText}
              mandate={
                fields.fieldId !== "endOfProgramDate" && Constants.REQUIRED
              }
            />
            <Form.Control
              type={fields.fieldType}
              id={fields.fieldId}
              name={fields.fieldId}
              value={
                merchantApprovalState.merchantDetails[fields.fieldId] || ""
              }
              onChange={(e) => onChange(fields.fieldId, e)}
              min={
                fields.fieldId === "firstReceiptDate"
                  ? todaysDate
                  : fields.fieldId === "endOfProgramDate"
                  ? selectedFirstReceiptAndEndDate?.firstReceiptDate
                  : null
              }
              max={
                new Date().getFullYear() +
                200 +
                "-" +
                (new Date().getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                new Date()
                  .getDate()
                  .toString()
                  .padStart(2, "0")
              }
            />
            {merchantApprovalState.errors &&
              merchantApprovalState.errors[fields.fieldId] && (
                <div key={fields.fieldId} style={{ color: "#d64a4a" }}>
                  {merchantApprovalState.errors[fields.fieldId]}
                </div>
              )}
          </Form.Group>
        );
        break;
      default:
        break;
    }
    return field;
  };

  const onStoreLocationsChange = (selectedStoreOptions) => {
    const { storeLocationsList = [] } = merchantApprovalState;
    let updateStoreLocationsList = storeLocationsList;
    let updateAvailableStoreLocationOptions = [];
    let updateSelectedStoreLocation = [];
    let updateStoreLocationsInvolved = [];

    if (selectedStoreOptions !== null && selectedStoreOptions?.length > 0) {
      selectedStoreOptions.map((option) => {
        if (option.value === "all") {
          updateStoreLocationsInvolved =
            updateStoreLocationsList?.length > 0 &&
            updateStoreLocationsList.slice(1).map((stl) => stl.value);
          updateAvailableStoreLocationOptions = [];
          updateSelectedStoreLocation = [selectAllLocations];
        } else {
          updateAvailableStoreLocationOptions = [...updateStoreLocationsList];
          updateSelectedStoreLocation = selectedStoreOptions.map((storeLoc) => {
            let storeLocObj = {
              label: storeLoc.value,
              value: storeLoc.value,
            };

            return storeLocObj;
          });
          updateStoreLocationsInvolved = updateSelectedStoreLocation.map(
            (stl) => stl.value
          );
        }
      });
    } else {
      updateStoreLocationsInvolved = null;
      updateAvailableStoreLocationOptions = [...updateStoreLocationsList];
      updateSelectedStoreLocation = [];
    }

    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      merchantDetails: {
        ...merchantApprovalState.merchantDetails,
        storeLocationsInvolved: updateStoreLocationsInvolved,
      },
      availableStoreLocationOptions: updateAvailableStoreLocationOptions,
      selectedStoreLocation: updateSelectedStoreLocation,
      valuesChanged: true,
    }));
  };

  const toggleMerchantModal = () => {
    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      openMerchantModalFlag: !merchantApprovalState.openMerchantModalFlag,
    }));
  };

  const getDVNSetupState = (hierarchyArr = null, duns = null) => {
    //pass the merchantApprovalState to the func param and set the merchantApprovalState here
    setMerchantApprovalState((merchantApprovalState) => {
      let merchantDetails = { ...merchantApprovalState.merchantDetails };
      if (hierarchyArr) {
        merchantDetails.hierarchy = hierarchyArr;

        merchantDetails.needDVN = evaluateDVNNeed(hierarchyArr);
      } else if (duns !== null) {
        merchantDetails.duns = duns;
      }

      return { ...merchantApprovalState, merchantDetails, valuesChanged: true };
    });
  };

  const hierarchyHasDuplicate = (val) =>
    setMerchantApprovalState((state) => ({
      ...state,
      hierarchyDuplicate: val,
    }));

  const evaluateDVNNeed = (hierarchyArr) => {
    let needDVN = false;

    hierarchyArr.forEach((hier) => {
      if (hier.vendorNumber === "0") needDVN = true;
    });

    return needDVN;
  };

  const dunsValidatorHandler = (dunsFlags) => {
    setMerchantApprovalState((merchantApprovalState) => ({
      ...merchantApprovalState,
      merchantDetails: {
        ...merchantApprovalState.merchantDetails,
        ...dunsFlags,
      },
    }));
  };

  const checkIfEligibleForSubmitToMerchOps = () => {
    return new Promise((resolve) => {
      const vendorProfileId = localStorage.getItem("vid");
      if (vendorProfileId) {
        httpGetMandatoryDocumentStatus(vendorProfileId)
          .then((res) => {
            if (res.data) {
              const mandatoryDocStatusRes = checkMandatoryDocStatus(
                store.vendorStatus.onboardingStatus,
                res.data
              );
              props.setDocumentStatusRes(res.data || {});
              dispatch(updateCommonInfo({ mandatoryDocRes: res?.data || {} }));
              resolve(mandatoryDocStatusRes);
            } else {
              resolve(null);
            }
          })
          .catch((err) => {
            setEligibleForSubmitToMerchOps(false);
            dispatch(updateCommonInfo({ mandatoryDocRes: {} }));
            resolve(null);
          });
      } else {
        setEligibleForSubmitToMerchOps(false);
        resolve();
      }
    });
  };

  const submitToMerchantOps = () => {
    setSubmitToMerchOpsActionInProgress(true);

    let vendorDataToSubmit = {
      vendorProfileId: store.profileId,
      submittedBy: Cookie.get("email"),
      lastActivity:
        store?.merchandiseType ===
          Constants.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
        store?.vendorConnectionPlatform ===
          Constants.STATUS_PLATFORMTYPE_DIRECTEDI
          ? "beginIntegration"
          : "submittedToMerchOps",
      lastUpdatedBy: Cookie.get("email"),
      hierarchy: store.vendorProfile?.vendorDetail?.hierarchyDetails || [],
    };

    httpPostSubmitToDbmOrMerchOps(vendorDataToSubmit)
      .then((res) => {
        const responseStatus = res.data && res.data.status;

        // update vendorProfile in store from merchantDetails if required
        dispatch(
          updateVendorProfileDetails({
            status: responseStatus,
            lastUpdatedBy: Cookie.get("email"),
          })
        );

        //Update vendor status in store
        getVendorStatusDetails(store.profileId)
          .then((vendorStatus) => {
            const { mutatedVendorStatus } = extractVendorStatus(
              responseStatus,
              vendorStatus
            );
            dispatch(updateServiceData({ vendorStatus }));
            dispatch(
              updateCommonInfo({
                boardingStatuses: mutatedVendorStatus,
              })
            );
            setShowSubmitToMerchOps(false);
            setSubmitToMerchOpsActionInProgress(false);
          })
          .catch((error) => {
            console.log("Error during vendor status reload: ", error);
            setSubmitToMerchOpsError("There is some error !!");
            setSubmitToMerchOpsActionInProgress(false);
          });
      })
      .catch((err) => {
        const errorMessage =
          err.response && err.response.data && err.response.data.message;
        console.log(errorMessage);
        setSubmitToMerchOpsError("There is some error !!");
        setSubmitToMerchOpsActionInProgress(false);
      });
  };

  const getBrandMappingState = (hasBrandMapping = false) => {
    setHasBrandMapping(hasBrandMapping);
  };

  const getMbeWbeAgreementDetails = () => {
    let vendorId = store?.vendorProfile?.vendorDetail?.id;
    httpGetConsignmentContractStatusById(vendorId, Constants.DEI_TYPE)
      .then((response) => {
        setDisableSubmitDBMForMbeWbeVendorSign(
          !response?.data?.contractSignedByVendor
        );
      })
      .catch((error) => {
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          errorMsg: `Problem fetching MBE/WBE contract details, try after sometime!`,
          errorStatus: true,
        }));
      });
  };
  const validateFieldsForSubmitDBMMerchOpsBtn = () => {
    let isValid = true;
    if (
      merchantApprovalState.merchantDetails &&
      merchantApprovalState.merchantDetails["vendorConnectionPlatform"]
    ) {
      if (
        merchantApprovalState.merchantDetails["vendorConnectionPlatform"] ===
        Constants.NEW_BIG_TKT_VENDOR_FLAG
      ) {
        Fields.forEach((field) => {
          if (!merchantApprovalState.merchantDetails[field.fieldId]) {
            isValid = false;
          }
        });
      } else {
        Fields.forEach((field) => {
          if (
            field.fieldId !== "frieghtType" &&
            !merchantApprovalState.merchantDetails[field.fieldId]
          ) {
            isValid = false;
          }
        });
      }
    } else {
      isValid = false;
    }

    return isValid;
  };

  let disableSubmitDBMMerchOpsBtn = false;
  if (store.needDVN) {
    const updateddNeedDBM = String(
      evaluateDVNNeed(merchantApprovalState?.merchantDetails?.hierarchy)
    );
    if (
      store.needDVN !== updateddNeedDBM ||
      !hasBrandMapping ||
      merchantApprovalState.valuesChangedForSubmitDBMMerchOpsBtn
    ) {
      disableSubmitDBMMerchOpsBtn = true;
    }
  }

  const accessGmmChiefMearchantApproveBtn = () => {
    return (
      ((checkOnBoardingStatus(props?.onboardingStatus, [
        Constants.GMM_PENDING,
      ]) &&
        checkUserRoles([Constants.BDS_GMM]) &&
        store?.vendorProfile?.vendorDetail?.gmmSubmittedTo ===
          Cookie.get("email")) ||
        (checkOnBoardingStatus(props?.onboardingStatus, [
          Constants.CHIEF_MERCHANT_PENDING,
        ]) &&
          checkUserRoles([Constants.BDS_CHIEF_MERCHANT]))) &&
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
        RolePermissionConstants.VMP_BDSGMMCHIEFMERCHANTAPPROVEBUTTON
      ) === RolePermissionConstants.VIEW
    );
  };
  const handleGmmChiefmerchApproval = (onboardingStatus) => {
    const payload = {
      vendorProfileId: store?.vendorProfile?.vendorDetail?.id,
      approverEmail: Cookie.get("email"),
      approverRole: onboardingStatus,
      approverAction: "Approve",
    };
    httpPostRequestGmmChiefmerchApproval(payload)
      .then((res) => {
        props.refreshDataAfterActionSuccessful();
        setShowApproveGmmChiefMerchantModel(false);
      })
      .catch((err) => {
        setShowApproveGmmChiefMerchantModel(false);
        this.setState({
          errorMsg: `Problem in ${store?.vendorStatus?.onboardingStatus} approval, try after sometime!`,
          errorStatus: true,
        });
      });
  };

  const getConsignmentAgreementDetails = () => {
    let vendorId = store?.vendorProfile?.vendorDetail?.id;
    httpGetConsignmentContractStatusById(vendorId, Constants.CONSIGNMENT_TYPE)
      .then((response) => {
        const { contractModified = false } = response?.data;
        if (contractModified) {
          setIsConsignmentContractModified(contractModified);
        }
      })
      .catch((error) => {
        setMerchantApprovalState((merchantApprovalState) => ({
          ...merchantApprovalState,
          errorMsg: `Problem fetching consignment contract details, try after sometime!`,
          errorStatus: true,
        }));
      });
  };

  return (
    <fieldset disabled={props.onboardingStatusFlag && !pageAccessBasedOnRole}>
      <div data-testid="merchant-approval-container" style={{ marginTop: 20 }}>
        {store.merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
          dbmModalOpen && (
            <MerchantDbmApprovalModal
              open={dbmModalOpen}
              handkeOkHandle={handleDbmBtnCloseHandler}
              handkeCloseHandle={handleDbmBtnCloseHandler}
              profileId={store.profileId}
              vendorDetail={store.vendorProfile}
              hierarchy={
                store.vendorProfile?.vendorDetail?.hierarchyDetails || []
              }
            />
          )}
        {store.merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
          merchantApprovalState.openMerchantModalFlag && (
            <MerchantContactsModal
              open={true}
              toggleMerchantModal={toggleMerchantModal}
              merchantContact={store.merchantContact}
              multipleMerchantContactList={store.multipleMerchantContactList}
              vendorProfile={store.vendorProfile}
            />
          )}
        {merchantApprovalState.rolePermissionStatus &&
          merchantApprovalState.rolePermissionStatus !==
            RolePermissionConstants.NONE && (
            <div className="m-top-10">
              <ErrorContainer
                errorMsg={merchantApprovalState.errorMsg}
                updateStatus={merchantApprovalState.updateStatus}
                successMsg={merchantApprovalState.successMsg}
                errorStatus={merchantApprovalState.errorStatus}
                errorStyle="errorMessage"
                successStyle="successMessage"
              />
              <div
                className={`${
                  store.merchandiseType ===
                  Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
                    ? "mpContainer "
                    : ""
                }m-top-n20 container`}
              >
                {store.merchandiseType !==
                  Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                  <div className="flexContainer mb-2">
                    {store.merchantContact?.email &&
                      RolePermissionConstants.NONE !==
                        getUserRolePermission(
                          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
                          RolePermissionConstants.VMP_MANAGEMERCHANTCONTACTS
                        ) && (
                        <Button
                          id="manageMerchantContactsBtn"
                          size="md"
                          className="btn-primary-merchant"
                          disabled={
                            RolePermissionConstants.EDIT !==
                            getUserRolePermission(
                              RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
                              RolePermissionConstants.VMP_MANAGEMERCHANTCONTACTS
                            )
                          }
                          onClick={toggleMerchantModal}
                        >
                          {Constants.BUTTON_MANAGE_MERCHANT_CONTACTS}
                        </Button>
                      )}
                  </div>
                )}
                {store.merchandiseType !==
                  Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                  <div
                    style={{
                      padding: 10,
                      margin: "20px 0",
                      backgroundColor: "#fcfcfc",
                      boxShadow:
                        "rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px",
                      borderRadius: "2px",
                    }}
                  >
                    <DVNSetup
                      vendorProfileDetails={store.vendorProfile.vendorDetail}
                      onboardingStatus={store.vendorStatus.onboardingStatus}
                      viewOnMerchApproval={true}
                      merchApprovalStateUpdate={getDVNSetupState}
                      merchantApprovalState={merchantApprovalState}
                      hierarchyHasDuplicate={hierarchyHasDuplicate}
                      dunsValidatorHandler={dunsValidatorHandler}
                      dunsExists={
                        merchantApprovalState.merchantDetails.dunsExists
                      }
                      parentAccessDisabled={
                        !merchantApprovalState.editPermission
                      }
                      parentStatusMsgRefreshHandler={resetMessage}
                      submitMerchantContactApproval={
                        submitMerchantContactApproval
                      }
                      history={props.history}
                      validator={validator.allValid()}
                      merchApprovalBrandMappingUpdate={getBrandMappingState}
                    />
                  </div>
                )}
                <Form
                  name="merchantForm"
                  className={`${
                    store.merchandiseType ===
                    Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE
                      ? "d-flex flex-column justify-content-between"
                      : ""
                  }`}
                >
                  <Form.Row>
                    {store?.configValues?.length > 0 &&
                      Fields.map((fields, index) => {
                        if (
                          store.merchandiseType ===
                            Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                          fields.fieldId !== "vendorConnectionPlatform" &&
                          fields.fieldId !== "productType"
                        ) {
                          return null;
                        }

                        if (
                          store.merchandiseType ===
                            Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                          fields.fieldId === "vendorConnectionPlatform"
                        ) {
                          fields.fieldType = "text";
                        }
                        return getFields(fields, index);
                      })}
                    {isBloomingdalesMerchantEmail(
                      store?.merchantContact?.email,
                      store?.merchandiseType
                    ) &&
                      ConsignmentBloomingdales.map((fields, index) => {
                        return getFields(fields, index);
                      })}
                  </Form.Row>
                  {store.merchandiseType ===
                    Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                    marketPlaceFields.map((fields, index) => {
                      return (
                        <Form.Row>
                          <Form.Group
                            as={Col}
                            md={3}
                            key={index}
                            style={{ paddingTop: "5px" }}
                          >
                            <ToolTip
                              toolTipId={fields.toolTipId}
                              customStyles="compDetailsFormLabel"
                              label={fields.fieldLabel}
                              toolTipText={fields.toolTipText}
                            />
                          </Form.Group>
                          <Form.Group as={Col} md={1} key={index}>
                            <Form.Control
                              type={fields.fieldType}
                              id={fields.fieldId}
                              name={fields.fieldId}
                              value={
                                merchantApprovalState.merchantDetails[
                                  fields.fieldId
                                ] || ""
                              }
                              disabled
                              style={{ padding: "0.375rem 0.5rem" }}
                            />
                          </Form.Group>
                        </Form.Row>
                      );
                    })}
                  <Form.Row>
                    <div className="errorMailContent">
                      {merchantApprovalState.isEmailSent && (
                        <div>
                          <ErrorContainer
                            errorMsg={merchantApprovalState.emailErrorMsg}
                            errorStatus={merchantApprovalState.isEmailSent}
                            errorStyle="errorMessage"
                          />
                        </div>
                      )}
                    </div>
                    <Form.Group className="merBtnWrapper pl-9">
                      <div
                        style={{
                          width: "60%",
                        }}
                      >
                        {store.merchandiseType !==
                          Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                          <>
                            {eligibleForSubmitToMerchOps &&
                              validateFieldsForSubmitDBMMerchOpsBtn() && (
                                <>
                                  {store.needDVN === "true" ? (
                                    <Button
                                      id="merDbmApproveBtn"
                                      size="md"
                                      className="button-primary-md"
                                      onClick={handleDbmBtnHandler}
                                      disabled={
                                        disableSubmitDBMMerchOpsBtn ||
                                        disableSubmitDBMForMbeWbeVendorSign
                                      }
                                    >
                                      SUBMIT TO DBM
                                    </Button>
                                  ) : (
                                    <Button
                                      className="m-right-12 button-primary-md"
                                      onClick={() => {
                                        setShowSubmitToMerchOps(true);
                                      }}
                                      style={{ minWidth: 200 }}
                                      disabled={disableSubmitDBMMerchOpsBtn}
                                    >
                                      {store?.merchandiseType ===
                                        Constants.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
                                      store?.vendorConnectionPlatform ===
                                        Constants.STATUS_PLATFORMTYPE_DIRECTEDI
                                        ? Constants.BUTTON_BEGIN_INTEGRATION
                                        : "SUBMIT TO MERCH OPS"}
                                    </Button>
                                  )}
                                </>
                              )}
                          </>
                        )}
                        {accessGmmChiefMearchantApproveBtn() && (
                          <>
                            <Button
                              id="gmmChiefMerchantApproveBtn"
                              size="md"
                              className="button-primary-md"
                              onClick={(e) => {
                                e.target.blur();
                                setShowApproveGmmChiefMerchantModel(true);
                              }}
                              disabled={
                                store?.vendorProfile?.vendorDetail
                                  ?.anticipatedAverageStock != null &&
                                store?.vendorProfile?.vendorDetail
                                  ?.firstReceiptDate != null &&
                                store?.vendorProfile?.vendorDetail
                                  ?.storeLocationsInvolved != null
                                  ? false
                                  : true
                              }
                            >
                              Approve
                            </Button>
                            <ConfirmationModal
                              show={showApproveGmmChiefMerchantModel}
                              confirmationTitle={
                                Constants.GMM_CHIEFMERCHANT_APPROVAL_MODAL_TITLE
                              }
                              confirmationText={
                                Constants.GMM_CHIEFMERCHANT_APPROVAL_MODAL_QUESTION
                              }
                              okButtonText={
                                Constants.GMM_CHIEFMERCHANT_APPROVAL_MODAL_BUTTON_YES
                              }
                              cancelButtonText={
                                Constants.GMM_CHIEFMERCHANT_APPROVAL_MODAL_BUTTON_NO
                              }
                              forApproveDeny={true}
                              onOk={() => {
                                handleGmmChiefmerchApproval(
                                  store?.vendorStatus?.onboardingStatus ===
                                    Constants.GMM_PENDING
                                    ? "bdsGMM"
                                    : "bdsChiefMerchant"
                                );
                              }}
                              onDeny={() => {
                                setShowApproveGmmChiefMerchantModel(false);
                              }}
                              onCancel={() => {
                                setShowApproveGmmChiefMerchantModel(false);
                              }}
                            />
                          </>
                        )}

                        {getUserRolePermission(
                          RolePermissionConstants.VENDORPLATFORM_COMPANYINFORMATION_MERCHANTAPPROVAL,
                          RolePermissionConstants.VMP_SUBMIT_TO_ACCOUNT_PAYABLE_VP
                        ) === RolePermissionConstants.EDIT &&
                          store?.merchandiseType ===
                            Constants.VOB_MERCHANDISE_TYPE_CONSIGNMENT &&
                          ((props?.onboardingStatus !== "" &&
                            checkOnBoardingStatus(props?.onboardingStatus, [
                              Constants.CONSIGNMENT_ADMIN_PENDING,
                            ])) ||
                            isConsignmentContractModified) &&
                          store?.documentList?.length > 0 &&
                          store?.documentList?.some(
                            (doc) =>
                              doc.fileType === "ConsignmentContractFirstDraft"
                          ) && (
                            <Button
                              id="merSubmitToAPVPBtn"
                              size="md"
                              className="button-primary-md"
                              style={{ minWidth: 255 }}
                              onClick={handleSubmitToAPVPHandler}
                            >
                              SUBMIT TO ACCOUNT PAYABLE VP
                            </Button>
                          )}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          width: "40%",
                        }}
                      >
                        {/* Commenting out the Reject functionality of Merchant Approval page  */}
                        {/* {store.merchandiseType !==
                          Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE && (
                          <div className="manageApprovalBtn">
                            {(store.vendorStatus.onboardingStatus ===
                              Constants.VENDOR_SUBMISSION ||
                              store.vendorStatus.onboardingStatus ===
                                Constants.MERCHANT_APPROVED ||
                              store.vendorStatus.onboardingStatus ===
                                Constants.DOCUMENT_SUBMITTED ||
                              store.vendorStatus.onboardingStatus ===
                                Constants.ACCOUNTS_PAYABLE_APPROVED) && (
                              <button
                                id="rejectBtn"
                                className="m-right-12 button-later-md"
                                disabled={!merchantApprovalState.editPermission}
                                onClick={submitMerchantContactApproval}
                              >
                                {Constants.BUTTON_REJECT}
                              </button>
                            )}
                          </div>
                        )} */}
                        <Button
                          id="merApproveBtn"
                          size="md"
                          className="button-primary-md"
                          onClick={submitMerchantContactApproval}
                          disabled={
                            store.merchandiseType ===
                              Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE ||
                            !merchantApprovalState.valuesChanged ||
                            !validator.allValid() ||
                            !merchantApprovalState.editPermission ||
                            merchantApprovalState.disableBtn ||
                            merchantApprovalState.disableOnSubmit ||
                            merchantApprovalState.hierarchyDuplicate ||
                            !validFormFields()
                          }
                        >
                          Save
                        </Button>
                      </div>
                    </Form.Group>
                    {merchantApprovalState.merchantApproveErrFlag && (
                      <div className="merchantApproveError">
                        <OnSubmitErrorMessage
                          type="error"
                          message={merchantApprovalState.merchantApproveErrMgs}
                        />
                      </div>
                    )}
                  </Form.Row>
                </Form>
              </div>
            </div>
          )}
        {merchantApprovalState.rolePermissionStatus &&
          merchantApprovalState.rolePermissionStatus ===
            RolePermissionConstants.NONE && (
            <div>
              <ErrorContainer
                errorMsg={
                  RolePermissionConstants.VMP_MERCHANTAPPROVAL_PAGE_ACCESS_ERROR_MSG
                }
                errorStatus={merchantApprovalState.rolePermissionStatus}
                errorStyle="errorMessage"
              />
            </div>
          )}

        {store.merchandiseType !== Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
          showSubmitToMerchOps && (
            <ConfirmationModal
              show={true}
              onCancel={() => {
                setShowSubmitToMerchOps(false);
                setSubmitToMerchOpsError("");
              }}
              onOk={submitToMerchantOps}
              okButtonText="SUBMIT"
              confirmationText={
                store?.merchandiseType ===
                  Constants.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
                store?.vendorConnectionPlatform ===
                  Constants.STATUS_PLATFORMTYPE_DIRECTEDI
                  ? Constants.CONTENT_BEGIN_INTEGRATION
                  : "Are you sure you wish to submit this vendor record to Merch Ops for integration and order testing?"
              }
              confirmationTitle={
                store?.merchandiseType ===
                  Constants.VOB_MERCHANDISE_TYPE_OWNED_VENDOR &&
                store?.vendorConnectionPlatform ===
                  Constants.STATUS_PLATFORMTYPE_DIRECTEDI
                  ? Constants.BUTTON_BEGIN_INTEGRATION
                  : "SUBMIT TO MERCH OPS"
              }
              onError={submitToMerchOpsError}
              onActionInProgress={submitToMerchOpsActionInProgress}
            />
          )}
      </div>
    </fieldset>
  );
};

export default MerchantApproval;
